import "core-js/modules/es.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
import React from 'react';
import { compose } from 'recompose';
import accessibleIcon from '../../accessible-icon/accessible-icon';
import SvgIcon from '../../svg-icon/SvgIcon';

var SpinnerIcon = function SpinnerIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    version: "1.1",
    viewBox: "0 0 70 70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 17.3v-5.4V3 2.2H37.9C37.5 0.9 36.4 0 35 0c-1.4 0-2.5 0.9-2.9 2.2h-0.1v0.8 9 5.4c1-0.2 2-0.3 3-0.3C36 17.1 37 17.2 38 17.3z",
    fill: "#717276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4 21.2l2.7-4.7 4.5-7.8 0.4-0.7L53.9 8c0.3-1.3-0.2-2.6-1.4-3.3 -1.2-0.7-2.6-0.4-3.6 0.5l-0.1-0.1 -0.4 0.7 -4.5 7.8 -2.7 4.7c0.9 0.3 1.8 0.8 2.7 1.3S45.6 20.6 46.4 21.2z",
    fill: "#626468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8 28.7l4.7-2.7 7.8-4.5 0.7-0.4 -0.1-0.1c0.9-0.9 1.1-2.4 0.5-3.6 -0.7-1.2-2.1-1.7-3.3-1.4l-0.1-0.1 -0.7 0.4 -7.8 4.5 -4.7 2.7c0.6 0.8 1.2 1.6 1.7 2.4C51 26.9 51.4 27.8 51.8 28.7z",
    fill: "#44464B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7 38h5.4l9 0h0.8v-0.1C69.1 37.5 70 36.4 70 35c0-1.4-0.9-2.5-2.2-2.9v-0.1h-0.8 -9 -5.4c0.2 1 0.3 2 0.3 3S52.8 37 52.7 38z",
    fill: "#44464C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8 46.4l4.7 2.7 7.8 4.5 0.7 0.4L62 53.9c1.3 0.3 2.6-0.2 3.3-1.4 0.7-1.2 0.4-2.6-0.5-3.6l0.1-0.1 -0.7-0.4 -7.8-4.5 -4.7-2.7c-0.3 0.9-0.7 1.8-1.3 2.7C50 44.8 49.4 45.6 48.8 46.4z",
    fill: "#E8E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3 51.8l2.7 4.7 4.5 7.8 0.4 0.7 0.1-0.1c0.9 0.9 2.4 1.1 3.6 0.5 1.2-0.7 1.7-2.1 1.4-3.3l0.1-0.1 -0.4-0.7 -4.5-7.8L46.4 48.8c-0.8 0.6-1.6 1.2-2.4 1.7C43.1 51 42.2 51.4 41.3 51.8z",
    fill: "#DADADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 52.7l0 5.4 0 9 0 0.8 0.1 0C32.5 69.1 33.6 70 35 70c1.4 0 2.5-0.9 2.9-2.2h0.1l0-0.8 0-9 0-5.4c-1 0.2-2 0.3-3 0.3S33 52.8 32 52.7z",
    fill: "#CBCBCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6 48.8l-2.7 4.7 -4.5 7.8 -0.4 0.7 0.1 0.1c-0.3 1.3 0.2 2.6 1.4 3.3 1.2 0.7 2.6 0.4 3.6-0.5l0.1 0.1 0.4-0.7 4.5-7.8 2.7-4.7c-0.9-0.3-1.8-0.7-2.7-1.3C25.2 50 24.4 49.4 23.6 48.8z",
    fill: "#BCBCBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2 41.3l-4.7 2.7 -7.8 4.5 -0.7 0.4 0.1 0.1C4.2 49.9 4 51.3 4.7 52.5 5.4 53.7 6.7 54.2 8 53.9l0.1 0.1 0.7-0.4 7.8-4.5 4.7-2.7c-0.6-0.8-1.2-1.6-1.7-2.4C19 43.1 18.6 42.2 18.2 41.3z",
    fill: "#ADAEB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3 32h-5.4H3l-0.8 0 0 0.1C0.9 32.5 0 33.6 0 35c0 1.4 0.9 2.5 2.2 2.9l0 0.1 0.8 0 9 0 5.4 0c-0.2-1-0.3-2-0.3-3C17.1 34 17.2 33 17.3 32z",
    fill: "#9D9FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2 23.6l-4.7-2.7 -7.8-4.5 -0.7-0.4L8 16.1c-1.3-0.3-2.6 0.2-3.3 1.4 -0.7 1.2-0.4 2.6 0.5 3.6l-0.1 0.1 0.7 0.4 7.8 4.5 4.7 2.7c0.3-0.9 0.8-1.8 1.3-2.7C20 25.2 20.6 24.4 21.2 23.6z",
    fill: "#8F9093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 18.2l-2.7-4.7L21.6 5.8l-0.4-0.7L21.1 5.2c-0.9-0.9-2.4-1.1-3.6-0.5 -1.2 0.7-1.7 2.1-1.4 3.3l-0.1 0.1 0.4 0.7 4.5 7.8 2.7 4.7c0.8-0.6 1.6-1.2 2.4-1.7C26.9 19 27.8 18.6 28.8 18.2z",
    fill: "#717377"
  }));
};

SpinnerIcon.defaultProps = {
  width: '70px',
  height: '70px'
};
export default /*#__PURE__*/React.memo(compose(accessibleIcon)(SpinnerIcon));